<!-- (click) fires on mouse up. When Material input is focused and there is no value and trying to click the label, (click) will blur the input -->
<!-- on mouse down causing the label to resize and move. On mouse up, when click is fired, the mouse will no longer be -->
<!-- over the label and will not be able to click the label to localize it. Using (mousedown) fixes that issue. -->
@if (loc()) {
<div
	role="button"
	[ngClass]="{ 'no-loc': !loc, html: loc()?.htmlAllowed }"
	(mousedown)="localize($event)"
	[attr.data-loc]="loc()?.name">
	<div
		class="cm-localized-content"
		[innerHtml]="loc()?.value || noValueDisplay() | safeHtml"
		[style]="customInliningStyle() ?? ''"></div>
</div>
}
